<template>
  <h-frame type="right" v-model:defaultOpen="defaultOpen">
    <div class="homeRight">
      <div class="itemDetail">
        <x-title> 大数据研判预警统计 </x-title>
        <div class="rightOneBox">
          <div class="warn">
            <div class="blueColor">{{ alarmtotal }}</div>
            <!-- <div class="blueColor">0</div> -->
            <div class="warnText">预警总量</div>
          </div>
          <div class="warnright">
            <div class="warnTitle">
              今日预警:{{ carAlarmtotal + personAlarmtotal }}
            </div>
            <div class="warnItem">
              <div class="itemBg" @click="rightItemClick({ name: '人员' })">
                <span class="itenSize">{{ personAlarmtotal }}</span>
                <span>人员</span>
              </div>
              <div class="itemBg" @click="rightItemClick({ name: '车辆' })">
                <span class="itenSize">{{ carAlarmtotal }}</span>
                <span>车辆</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">实时事件上报</div>
        </x-title>
        <div class="event">
          <div class="eventTop">
            <div class="topItem">
              <div class="topLeft">
                <i :class="['iconfont', 'icon-jurassic_safe']"></i>
              </div>
              <div
                class="topRight"
                @click="rightItemClick({ name: '警情事件' })"
              >
                <span class="sizeNum blueColor">{{ eventTotal }}</span>
                <span>事件总量</span>
              </div>
            </div>
            <div class="topItem">
              <div class="topLeft">
                <i :class="['iconfont', 'icon-jurassic_safe']"></i>
              </div>
              <div class="topRight">
                <span class="sizeNum blueColor">{{ todayEventTotal }}</span>
                <span>今日上报</span>
              </div>
            </div>
          </div>
          <div class="eventBottom">
            <div class="tableTitle">
              <div class="titleName">名称</div>
              <div class="titleName">地点</div>
              <div class="titleName">上报人</div>
              <div class="titleName">上报人电话</div>
            </div>
            <div class="tableCount">
              <div
                class="tableList"
                v-for="(item, index) in eventList"
                :key="index"
              >
                <div class="tableItem text-ellipsis" :title="item.eventName">
                  {{ item.eventName }}
                </div>
                <div class="tableItem">{{ item.eventAddress }}</div>
                <div class="tableItem">{{ item.reporter }}</div>
                <div class="tableItem">
                  {{ item.reporterPhone }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">区域安全实况</div>
        </x-title>
        <div class="echarts" id="echartsTopRight" v-if="true"></div>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">实时抓拍</div>
        </x-title>
        <pictureCard
          v-if="eareInfoList"
          :pictureInfo="eareInfoList"
        ></pictureCard>
      </div>
    </div>
  </h-frame>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  watchEffect,
  onUnmounted,
  nextTick,
  inject,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { useRouter } from "vue-router";
import moment from "moment";
// import labelLegend from './labelLegend';
import pictureCard from "./pictureCard.vue";
import { getFindByCondition } from "@/api/alarmCenter/alarmCenter.js";
import {
  getEventCount,
  getEventList,
  getSecurity,
  getStrength,
  getEquipment,
  getDeviceWarning,
} from "@/api/home/home.js";
import { queryinstalled } from "@/api/smartApplication/personSearchApi.js";

export default defineComponent({
  name: "",
  components: { pictureCard },
  props: {},
  setup(props, context) {
    const data = reactive({
      imgURL: window.imgURL,
      eventList: [
        {
          name: "噪音扰民",
          type: "矛盾纠纷",
          addrens: "丰盛园社区",
          people: "张三",
        },
        {
          name: "噪音扰民",
          type: "矛盾纠纷",
          addrens: "丰盛园社区",
          people: "张三",
        },
      ],
      eareInfoList: null,
      defaultOpen: true,
      showEareItem: "1",
      alarmtotal: 0,
      carAlarmtotal: 0,
      personAlarmtotal: 0,
      eventTotal: 0, // 事件总量
      todayEventTotal: 0, // 今日事件总量
      dataname: ["安防设施", "力量装备", "研判预警", "设备告警", "实有警情"],
      datamax: [0, 0, 0, 0, 0],
      datavaule: [0, 0, 0, 0, 0],
      IntervalFace: null,
    });
    watchEffect(() => {
      context.emit("changeDefaultOpen", data.defaultOpen);
    });
    watchEffect(() => {});
    const refData = toRefs(data);
    const start = new Date();
    const router = useRouter();
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          // data.dataname = [];
          // data.datamax = [];
          // data.datavaule = [];
          indicator = [];
          getFindByConditionAsync();
          getEventCountAsync();
          getEventListAsync();
          queryinstalledtAsync();
          echartsTopRight();
        });
      }
    });
    const rightItemClick = (val) => {
      switch (val.name) {
        case "人员":
          router.push("faceWarning");
          break;
        case "车辆":
          router.push("vehicleWarning");
          break;
        case "通用":
          router.push("generalAlarm");
          break;
        case "警情事件":
          router.push("eventDispatch");
          break;
        case "安防设施":
          router.push("ActualSecurityFacilities");
          break;

        default:
          break;
      }
    };
    let myChartTopLeft;

    var indicator = [];

    function contains(arrays, obj) {
      var i = arrays.length;
      while (i--) {
        if (arrays[i] === obj) {
          return i;
        }
      }
      return false;
    }

    const echartsTopRight = async () => {
      await getRegionAsync();
      let max = data.datavaule.reduce((prev, item) => {
        return prev + Number(item);
      }, 0);
      data.datamax = [max, max, max, max, max];
      for (var i = 0; i < data.dataname.length; i++) {
        indicator.push({
          name: data.dataname[i],
          max: data.datamax[i],
        });
      }
      myChartTopLeft = echarts.init(document.getElementById("echartsTopRight"));
      const option = {
        tooltip: {
          show: false,
          trigger: "item",
        },
        radar: {
          center: ["50%", "50%"],
          radius: "65%",
          startAngle: 240,
          splitNumber: 5,
          splitArea: {
            areaStyle: {
              color: [
                "rgba(47,74,118, 1)",
                "rgba(41,76,135, 1)",
                "rgba(46,90,163, 1)",
                "rgba(61,116,189, 1)",
                "rgba(61,116,189, 1)",
                // 'rgba(47,74,118, 0.2)', 'rgba(47,74,118, 1)'
                // 'rgba(0,96,208, 0.1)', 'rgba(0,96,208, 0.2)',
                // 'rgba(0,96,208, 0.4)', 'rgba(0,96,208, 0.6)',
                // 'rgba(0,96,208, 0.8)', 'rgba(0,96,208, 1)'
              ].reverse(),
            },
          },
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "transparent",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "transparent",
            },
          },
          name: {
            formatter: function (value) {
              var i = contains(data.dataname, value);
              var percent = data.datavaule[i];
              var ret = ""; // 拼接加\n返回的类目项
              var maxLength = 6; // 每项显示文字个数
              var valLength = value.length; // X轴类目项的文字个数
              var rowN = Math.ceil(valLength / maxLength); // 类目项需要换行的行数
              if (rowN > 1) {
                // 如果类目项的文字大于6,
                var temp = ""; // 每次截取的字符串
                var start = 0; // 开始截取的位置
                var end = maxLength; // 结束截取的位置
                temp =
                  value.substring(start, end) +
                  "\n" +
                  value.substring(end, valLength);
                ret += temp; // 凭借最终的字符串
                return "{a|" + percent + "}\n" + "{b|" + ret + "}";
              } else {
                return "{a|" + percent + "}\n" + "{b|" + value + "}";
              }
            },
            textStyle: {
              rich: {
                a: {
                  color: "#FFFFFF",
                  fontSize: 15,
                  padding: [0, 0],
                  lineHeight: 20,
                },
                b: {
                  color: "#CAEEFF",
                  fontSize: 15,
                  padding: [0, 0],
                  lineHeight: 20,
                },
              },
            },
          },
          indicator: indicator,
        },

        series: [
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 1,
            areaStyle: {
              normal: {
                color: "rgba(116, 251, 207, 0.5)",
              },
            },
            itemStyle: {
              color: "#84E1FF",
              borderColor: "#00A7FE",
              borderWidth: 1,
            },
            // areaStyle: {
            //   normal: {
            //     color: '#444'
            //   }
            // },
            lineStyle: {
              normal: {
                color: "#74fbcf",
                width: 2,
              },
            },
            data: [data.datavaule],
          },
        ],
      };
      myChartTopLeft.setOption(option);
    };
    // 告警接口请求
    const getFindByConditionAsync = async () => {
      const start = new Date();
      const startTime = moment(start).format("YYYY-MM-DD");

      const params = {
        startTime: startTime + " 00:00:00",
        endTime: moment(start).format("YYYY-MM-DD HH:mm:ss"),
        type: "3",
      };
      const paramss = {
        startTime: startTime + " 00:00:00",
        endTime: moment(start).format("YYYY-MM-DD HH:mm:ss"),
        type: "2",
      };

      const res = await getFindByCondition(params);
      const ress = await getFindByCondition(paramss);
      params.startTime = "2022-06-01 00:00:00";
      paramss.startTime = "2022-06-01 00:00:00";
      const total2 = await getFindByCondition(params);
      const total3 = await getFindByCondition(paramss);
      if (res.code === 0) {
        data.carAlarmtotal = res.page.totalCount;
      }
      if (ress.code === 0) {
        data.personAlarmtotal = ress.page.totalCount;
      }
      data.datavaule[2] = res.page.totalCount + ress.page.totalCount;
      if (total3.code === 0) {
        data.alarmtotal =
          parseInt(total2.page.totalCount) + parseInt(total3.page.totalCount);
      }
    };
    // 事件总量
    const getEventCountAsync = async () => {
      const params = {
        startDate: moment(new Date()).format("YYYY-MM-DD ") + "00:00:00",
        endDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        regionIds: regionInfo.regionList.toString(),
      };
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await getEventCount(param);
      const resToday = await getEventCount(params);
      if (res) {
        data.eventTotal = res.data.value;
        data.datavaule[4] = res.data.value;
      }

      if (resToday) {
        data.todayEventTotal = resToday.data.value;
      }
    };
    // 事件总量列表
    const getEventListAsync = async () => {
      const params = {
        limit: 10,
        page: 1,
        reportTimeStart: moment(new Date()).format("YYYY-MM-DD ") + "00:00:00",
        reportTimeEnd: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
      const res = await getEventList(params);
      if (res) {
        data.eventList = res.page.list;
      }
    };
    // 区域安全实况
    const getRegionAsync = async () => {
      let params;
      if (regionInfo.regionList.length > 0) {
        params = {
          regionIds: regionInfo.regionList.toString(),
        };
      }
      // 设备告警总数
      const resDeviceWarning = await getDeviceWarning(params);
      if (resDeviceWarning) {
        data.datavaule[3] = resDeviceWarning.data.value;
      }
      // 安防
      const resSecurity = await getSecurity(params);
      if (resSecurity) {
        data.datavaule[0] = resSecurity.data.value;
      }
      // 设备+力量
      const res = await getStrength(params);
      const ress = await getEquipment(params);
      if (res && ress) {
        data.datavaule[1] = res.data.value + ress.data.value;
      }
    };
    // 人脸抓拍
    const queryinstalledtAsync = async () => {
      const begin = start.getTime() - 3600 * 1000 * 24 * 5;
      const from = {
        beginTime: moment(begin).format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment(start).format("YYYY-MM-DD HH:mm:ss"),
        limit: 20,
        page: 1,
      };
      const res = await queryinstalled(from);
      if (res) {
        data.eareInfoList = res.page.list.filter((item, index) => {
          return index < 3;
        });
      }
      console.log(data.eareInfoList);
    };
    // getFindByConditionAsync();
    // getEventCountAsync();
    // getEventListAsync();
    // queryinstalledtAsync();
    onMounted(() => {
      // echartsTopRight();
      window.addEventListener("resize", () => {
        myChartTopLeft.resize();
      });
      data.IntervalFace = setInterval(() => {
        queryinstalledtAsync();
      }, 1000 * 60 * 5);
    });
    onUnmounted(() => {
      clearInterval(data.IntervalFace);
    });
    return {
      ...refData,
      rightItemClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.dialog {
  position: absolute;
  position: absolute;
  bottom: 200px;
  right: 360px;
  transition: all 0.5s;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
.homeRight {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 10px;
  color: #fff;
  overflow: auto;
  display: grid;
  grid-template-rows: 20% 30% 25% 25%;
  // .itemDetail {
  //   height: 25%;
  // }
  .titleWidth {
    width: 100%;
  }
  .titleMore {
    float: right;
    cursor: pointer;
    margin-right: 15px;
  }
  .rightOneBox {
    width: 100%;
    display: flex;
    margin: 15px 0 7px 12px;
    .warn {
      width: 120px;
      height: 120px;
      background-image: url("~@/assets/images/home/yjbg.png");
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .warnText {
        font-size: 16px;
      }
    }
    .warnright {
      display: flex;
      flex-direction: column;
      flex: 1;
      // color: #a6bfda;
      .warnTitle {
        color: #73f1f3;
        text-align: center;
        // line-height: 24px;
        margin-bottom: 8px;
      }
      .warnItem {
        display: flex;
        justify-content: space-evenly;
        .itemBg {
          width: 78px;
          height: 62px;
          display: flex;
          flex-direction: column;
          background-image: url("~@/assets/images/home/yujing.png");
          background-size: 100% 100%;
          text-align: center;
          .itenSize {
            margin-top: 14px;
            margin-bottom: 30px;
          }
          span {
            font-size: 16px;
          }
        }
      }
    }
  }
  .event {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    .eventTop {
      display: flex;
      margin: 15px 0;
      justify-content: space-around;
      .topItem {
        display: flex;
      }
      .topLeft {
        width: 58px;
        height: 57px;
        margin-right: 10px;
        text-align: center;
        line-height: 57px;
        background-image: url("~@/assets/images/home/yuan.png");
        background-size: cover;
      }
      .topRight {
        display: flex;
        flex-direction: column;
        .sizeNum {
          font-size: 20px;
          margin-bottom: 5px;
        }
      }
    }
    .eventBottom {
      display: flex;
      flex-direction: column;
      line-height: 30px;
      font-size: 14px;
      .tableTitle {
        width: 100%;
        line-height: 30px;
        display: flex;
        margin-top: 10px;
        border-radius: 4px;
        background: #074c98;
        .titleName {
          width: 25%;
          padding: 0 5px;
          overflow: auto;
        }
      }
      .tableCount {
        width: 100%;
        .tableList {
          width: 100%;
          display: flex;
          .tableItem {
            width: 25%;
            height: 32px;
            padding: 0 5px;
            border-bottom: 1px solid #03297a;
          }
        }
      }
    }
  }
  .echarts {
    width: 100%;
    height: 90%;
  }

  .blueColor {
    color: #73f1f3;
  }
}
</style>
